import { useTranslation } from '../../../lib/i18n';
import type { MaestroWorking } from '../../../lib/maestro-working';
import { Card } from '../ui';
import styles from './maestro-working.module.css';

/**
 * "The Maestro is working now", pinned above the task list.
 *
 * NOT a task. It carries no status badge, is in no tab count, and cannot be cancelled or opened as a
 * task, because there is nothing persisted behind it — the Maestro working in the chat is not stored
 * as anything. If the turn produces a task or an outreach, those appear as rows of their own; if it
 * produces neither, the chat is the only record and this line vanishes with the turn.
 *
 * It renders only while the chat is CLOSED. With the chat open the transcript is already saying this,
 * in more detail than one line can.
 */
export function MaestroWorkingRow({ maestro, onOpen }: { maestro: MaestroWorking; onOpen: () => void }) {
  const { t } = useTranslation();
  if (!maestro.working) return null;

  return (
    <Card component="button" className={styles.row} onClick={onOpen}>
      <span className={styles.head}>
        {/* A breathing dot rather than a spinner: it says "running", not "loading", and it is the same
            mark the island uses for a live loop. */}
        <span className={styles.dot} aria-hidden />
        <span className={styles.title}>{t('agentsIsland.maestroWorking')}</span>
      </span>
      {/* The agent's own narration of what it is doing, when it has written one. Absent is fine — the
          line still says it is working, which is the part the user came for. */}
      {maestro.action ? (
        <span className={styles.action} dir="auto">
          {maestro.action}
        </span>
      ) : null}
    </Card>
  );
}
